module.exports = __webpack_public_path__ + "img/06-pic.6c311a72.png";